<template>
    <div class="my-referral-code">
        
        
        <div class="my-referral-code__title">Your Referral Code</div>
        
        
        <div class="my-referral-code__container">
            <span>{{ referralCode }}</span>
            <v-btn class="button--primary" @click="copyReferralCode">
                <v-icon><copy-code></copy-code></v-icon>
                <span class="text-body-2">Copy</span>
            </v-btn>
        </div>


    </div>
</template>




<script setup>

import CopyCode from '@/icons/CopyWhite.vue';
import { useSnackbar } from '@/composables/useSnackbar';
import { CopyToClipboard } from "@/utils/utils.ts";

const props = defineProps({
    referralCode: {
        type: String,
        required: true
    }
});

const { showSnackbar } = useSnackbar();

const copyReferralCode = () => {
    try {
        CopyToClipboard(props.referralCode);
        showSnackbar({
            message: 'Copied to clipboard!',
            color: 'info'
        });
    } catch (err) {
        showSnackbar({
            message: 'Error copying to clipboard',
            color: 'error'
        });
    }
};

</script>